export enum DEVICES_LANDSCAPE_SIZES {
  MOBILE = 900,
  TABLET = 1024,
  DESKTOP = 1920,
}
